import { Component } from "@angular/core";
import { Subject } from "rxjs";
import { ThisPlatform } from "src/app/_services/platform.service";
import { SpaceService } from "src/app/_services/space.service";
import { SpaceType } from "src/app/_types/space-type";
import { MapWorkingMode } from "../space-map/space-map.model";

@Component({
  selector: "app-space-map-edit",
  templateUrl: "./space-map-edit.component.html",
  styleUrls: ["./space-map-edit.component.scss"],
})
export class SpaceMapEditComponent {
  constructor(public p: ThisPlatform, public spaceService: SpaceService) {}

  eventsSubject: Subject<void> = new Subject<void>();
  enableMovingSubject: Subject<boolean> = new Subject<boolean>();

  enableMovingSpace: boolean = false; //

  spaceType: typeof SpaceType = SpaceType;
  workingMode: typeof MapWorkingMode = MapWorkingMode;

  disableSpaceMapMovingButton: boolean = true;

  onToggleFilter() {
    this.eventsSubject.next();
  }

  onEnableMovingSpaces() {
    this.enableMovingSpace = !this.enableMovingSpace;
    this.enableMovingSubject.next(this.enableMovingSpace);
  }

  enableMovingSpacesButton(showSpaceMapMovingButton) {
    this.disableSpaceMapMovingButton = !showSpaceMapMovingButton;
  }
}
